import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { IonSlides, IonSlide } from '@ionic/react';
import { AuthSelectors } from 'redux/AuthRedux';
import { PaySelectors } from 'redux/PayRedux';
import moment from 'moment';
import api_v2 from 'services/api_v2';
import { currentToVenueDate } from 'utils/date';
import SlideItem from './SlideItem';

const slideOpts = {
  initialSlide: 0,
  slidesPerView: 'auto',
  centeredSlides: true,
  loop: false, // https://github.com/ionic-team/ionic-framework/issues/22414
  spaceBetween: 5,
  speed: 400,
};

function PromotionSlides({ venueId }) {
  const [availablePromotions, setAvailablePromotions] = useState([]);
  const loyaltyAnnualOffers = useSelector(
    PaySelectors.selectLoyaltyAnnualOffers
  );
  const token = useSelector(AuthSelectors.selectToken);

  useEffect(() => {
    async function getAvailablePromotions() {
      const apiV2 = api_v2(token);

      try {
        const venueDetail = await apiV2.getVenue(venueId);
        console.log('>>>>>>>>>>>> venueDetail', venueDetail);

        const day = currentToVenueDate(
          new Date(),
          venueDetail.settings.hours.endOfNight
        )
          .format('ddd')
          .toLowerCase();

        const promotions = await apiV2.getPromotions({ venueId, day });

        const annualOffers = loyaltyAnnualOffers.filter((item) => {
          if (item.offer && item.offer.venueId === venueId) {
            const currentDate = moment();
            const weekEnd = currentDate.clone().endOf('week');
            const monthEnd = currentDate.clone().endOf('month');
            let endOfDate = currentDate;

            if (item.offer.offer_type === 'annual') {
              if (item.offer.offer_duration_type === 'limited') {
                endOfDate = item.offer.offer_end_date;
              } else if (item.offer.annual_event_timeframe === 'day') {
                endOfDate = currentDate;
              } else if (item.offer.annual_event_timeframe === 'week') {
                endOfDate = weekEnd;
              } else {
                endOfDate = monthEnd;
              }
            } else {
              endOfDate = item.offer.offer_end_date;
            }

            const expiresAt = moment(endOfDate);
            const now = moment().startOf('day');

            return expiresAt.isSameOrAfter(now);
          }

          return false;
        });

        console.log('>>>>>>>>>>>> promotions', promotions);
        console.log('>>>>>>>>>>>> annualOffers', annualOffers);
        setAvailablePromotions([...annualOffers, ...promotions]);
      } catch (e) {
        console.log("get available promotions error: ", e.message);
      }
    }

    if (token && venueId) getAvailablePromotions();
  }, [token, loyaltyAnnualOffers, venueId]);

  if (!availablePromotions.length) {
    return null;
  }

  const key = availablePromotions.map((p) => p.discountId).join('-');

  return (
    <div className="promotions">
      <div className="promotions__title">
        {availablePromotions.length}
        {' promotion'}
        {availablePromotions.length > 1 ? 's' : ''} available
      </div>
      <IonSlides key={key} options={slideOpts}>
        {availablePromotions.map((p) => (
          <IonSlide key={p.id}>
            <SlideItem promotion={p} />
          </IonSlide>
        ))}
      </IonSlides>
    </div>
  );
}

PromotionSlides.propTypes = {
  venueId: PropTypes.string,
};

export default PromotionSlides;
